import React, { memo } from 'react';
import { css } from '@emotion/css';

import { useTranslation } from '@lyearn/i18n';
import { Play } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Image, Stack } from '@lyearn/ui';
import { getAdaptedBaseCardContent } from '@/modules/content/card/utils/getAdaptedBaseCardContent';
import * as BaseCard from '@/modules/content/components/ContentCard/BaseCard';
import DefaultCard from '@/modules/content/components/ContentCard/DefaultCard';

import { cardSizeMobileStyles, cardSizeStyles } from '../../styles';
import { NewDefaultCardProps } from '../types';

export const imageStyles = (height: number) => css`
  height: ${height}rem;
`;

export const DEFAULT_CARD_SIZE = {
  web: {
    height: 15.8,
    width: 37.6,
  },
  mobile: {
    height: 11.2,
    width: 36.4,
  },
};

const gradientOverlay = css`
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.4) 40%,
    rgba(0, 0, 0, 0) 100%
  );
`;

export const defaultCardSizeStyles = cn(
  cardSizeStyles(DEFAULT_CARD_SIZE.web),
  cardSizeMobileStyles(DEFAULT_CARD_SIZE.mobile as any),
);

//re move from here
const MiniCardMicroLearning: React.FC<NewDefaultCardProps & { showPlayButton: boolean }> = (
  props,
) => {
  const { className, baseContent, content: contentProp, showPlayButton } = props;
  const { t } = useTranslation();

  const content = baseContent ?? getAdaptedBaseCardContent(t, contentProp);

  return (
    <DefaultCard
      className={cn(className, 'flex-1 relative w-full h-full')}
      content={content}
      disabled={true}
      overrideDefaultStyle={cn(defaultCardSizeStyles, 'w-full')}>
      <Image className="w-full h-full object-cover" src={content?.image as string} />
      <Stack className="absolute h-full w-full" direction="col">
        <BaseCard.Bookmark />
        <Stack className="absolute bottom-0 left-0 w-full" direction="col">
          <Stack className={gradientOverlay} direction="col">
            <Stack alignItems="start" className="p-20 pt-16 xs:px-16" direction="col">
              <BaseCard.Label className="!text-text-white" />
              <BaseCard.Name className="mt-6 xs:mt-4 !text-text-white" numberOfLines={2} />
            </Stack>
          </Stack>
        </Stack>

        {/* Center PlayCircle */}
        <Stack alignItems="center" className="absolute inset-0" justifyContent="center">
          {showPlayButton ? <Play className="h-64 w-64" fillColorToken="icon-white" /> : null}
        </Stack>
      </Stack>
    </DefaultCard>
  );
};

export default memo(MiniCardMicroLearning);
